import { Real } from "@siteimprove/alfa-math";
import { LengthPercentage } from "../numeric/index.js";
import { Value } from "../value.js";
/**
 * @internal
 */
export var Corner;
(function (Corner) {
    function hasCalculation(corner) {
        return LengthPercentage.isLengthPercentage(corner)
            ? Value.hasCalculation(corner)
            : Value.hasCalculation(corner[0] || Value.hasCalculation(corner[1]));
    }
    Corner.hasCalculation = hasCalculation;
    function resolve(resolver) {
        function resolveAndClamp(radius) {
            const resolved = LengthPercentage.resolve(resolver)(radius);
            return LengthPercentage.of(Real.clamp(resolved.value, 0, Infinity), resolved.unit);
        }
        return (value) => LengthPercentage.isLengthPercentage(value)
            ? resolveAndClamp(value)
            : [resolveAndClamp(value[0]), resolveAndClamp(value[1])];
    }
    Corner.resolve = resolve;
    function partiallyResolve(resolver) {
        function resolveAndClamp(radius) {
            const resolved = LengthPercentage.partiallyResolve(resolver)(radius);
            if (resolved.hasCalculation()) {
                return resolved;
            }
            const clamped = Real.clamp(resolved.value, 0, Infinity);
            return LengthPercentage.isPercentage(resolved)
                ? LengthPercentage.of(clamped)
                : LengthPercentage.of(clamped, resolved.unit);
        }
        return (value) => LengthPercentage.isLengthPercentage(value)
            ? resolveAndClamp(value)
            : [resolveAndClamp(value[0]), resolveAndClamp(value[1])];
    }
    Corner.partiallyResolve = partiallyResolve;
})(Corner || (Corner = {}));
//# sourceMappingURL=corner.js.map